<template>
    <tr class="kgr-table__row">
        <td class="kgr-table__cell kgr-table__cell--centered">
            <kgr-isbj-status :status="status" />
        </td>
        <td class="kgr-table__cell">
            <a
                v-if="child.kindergarten.hasWriteAccess"
                :href="child.loginLink"
            >
                <span class="kgr-text--bold">{{ child.name.lastName }}</span>
            </a>
        </td>
        <td class="kgr-table__cell">
            <a
                v-if="child.kindergarten.hasWriteAccess"
                :href="child.loginLink"
            >
                <span class="kgr-text--bold">{{ child.name.firstName }}</span>
            </a>
        </td>
        <td class="kgr-table__cell">
            {{ child.kindergarten.name }}
        </td>
        <td class="kgr-table__cell diff">
            <template v-if="!subvention || !subvention.number">
                {{ $t('kein Gutschein') }}
            </template>
            <template v-else>
                <div class="diffContainer">
                    <div>KigaRoo:</div>
                    <div>
                        <kgr-isbj-voucher-tooltip
                            :voucher-number="subvention.number"
                            :federation-id="federationId"
                        />
                    </div>
                </div>
                <div class="diffContainer">
                    <div>ISBJ:</div>
                    <div>-</div>
                </div>
            </template>
        </td>
        <td class="kgr-table__cell diff">
            <template v-if="relatedContract !== null && relatedContract.id !== null">
                <div class="diffContainer">
                    <div>KigaRoo:</div>
                    <div>-</div>
                </div>
                <div class="diffContainer">
                    <div>ISBJ:</div>
                    <div>{{ relatedContract.contractNumber }}</div>
                </div>
            </template>
            <div v-else>
                {{ $t('keine registrierten Verträge') }}
            </div>
        </td>
        <td
            class="kgr-table__cell"
            :class="{ diff: regularTime.start.hasDiff }"
        >
            <template v-if="regularTime.start.hasDiff">
                <div class="diffContainer">
                    <div>KigaRoo:</div>
                    <div>{{ regularTime.start.kigaRoo }}</div>
                </div>
                <div class="diffContainer">
                    <div>ISBJ:</div>
                    <div>{{ regularTime.start.isbj }}</div>
                </div>
            </template>
            <div v-else>
                {{ regularTime.start.kigaRoo }}
            </div>
        </td>
        <td
            class="kgr-table__cell"
            :class="{ diff: regularTime.end.hasDiff }"
        >
            <template v-if="regularTime.end.hasDiff">
                <div class="diffContainer">
                    <div>KigaRoo:</div>
                    <div>{{ regularTime.end.kigaRoo }}</div>
                </div>
                <div class="diffContainer">
                    <div>ISBJ:</div>
                    <div>{{ regularTime.end.isbj }}</div>
                </div>
            </template>
            <div v-else>
                {{ regularTime.end.kigaRoo }}
            </div>
        </td>
        <td
            class="kgr-table__cell"
            :class="{ diff: regularTime.scope.hasDiff }"
        >
            <template v-if="regularTime.scope.hasDiff">
                <div class="diffContainer">
                    <div>KigaRoo:</div>
                    <div>{{ regularTime.scope.kigaRoo ? $t(`isbj.scope.${regularTime.scope.kigaRoo}`) : '-' }}</div>
                </div>
                <div class="diffContainer">
                    <div>ISBJ:</div>
                    <div>{{ regularTime.scope.isbj ? $t(`isbj.scope.${regularTime.scope.isbj}`) : '-' }}</div>
                </div>
            </template>
            <div v-else>
                {{ regularTime.scope.kigaRoo ? $t(`isbj.scope.${regularTime.scope.kigaRoo}`) : '-' }}
            </div>
        </td>
        <td
            class="kgr-table__cell"
            :class="{ diff: child.issues.length > 0 }"
        >
            <div v-for="issue in child.issues">
                {{ issue }}
            </div>
        </td>
        <td class="kgr-table__cell kgr-table__cell--centeredVertically kgr-table__cell--actions">
            <kgr-icon
                :disabled="buttonStatus.refresh.indexOf(child.id) !== -1"
                icon-class="refresh"
                :title="$t('Daten aktualisieren')"
                @click="refreshChild()"
            />
            <kgr-icon
                :disabled="status.key === 'pending_sync' || !subvention || !subvention.number || relatedContract.id !== null"
                :pending="subvention && buttonStatus.register.indexOf(subvention.id) !== -1"
                icon-class="sign"
                :title="$t('Vertrag registrieren')"
                @click="registerContract()"
            />
            <kgr-icon
                disabled
                icon-class="date_range"
                :title="$t('Vertragslaufzeit anpassen')"
            />
            <kgr-icon
                :disabled="status.key === 'pending_sync' || relatedContract.contractNumber === null"
                :pending="relatedContract.id != null && buttonStatus.contract.indexOf(relatedContract.id)"
                icon-class="clock"
                :title="$t('Betreuungsumfang anpassen')"
                @click="changeScopeOfCare()"
            />
            <kgr-icon
                disabled
                icon-class="cancel"
                :title="$t('Vertrag stornieren')"
            />
        </td>
    </tr>
</template>

<script>
import Icon from '../../common/icon/Icon';
import IsbjChildRepository from '../../../js/repository/IsbjChildRepository';
import IsbjStatus from './IsbjStatus';
import IsbjVoucherTooltip from './IsbjVoucherTooltip';

export default {
    components: {
        'kgr-icon': Icon,
        'kgr-isbj-status': IsbjStatus,
        'kgr-isbj-voucher-tooltip': IsbjVoucherTooltip,
    },
    props: {
        status: {
            type: Object,
            required: true,
        },
        child: {
            type: Object,
            required: true,
        },
        subvention: {
            type: Object,
            required: false,
        },
        regularTime: {
            type: Object,
            required: true,
        },
        relatedContract: {
            type: Object,
            required: false,
        },
        federationId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            buttonStatus: {
                refresh: [],
                register: [],
                contract: [],
            },
        };
    },
    methods: {
        refreshChild() {
            this.buttonStatus.refresh.push(this.child.id);
            IsbjChildRepository
                .update(this.child.id)
                .then(() => {
                    this.$emit('reload');
                    this.buttonStatus.refresh.splice(this.buttonStatus.refresh.indexOf(this.child.id), 1);
                })
                .catch((error) => this.showErrors(error));
        },
        registerContract() {
            this.buttonStatus.register.push(this.subvention.id);
            IsbjChildRepository
                .registerContract(this.subvention.id, this.subvention.type)
                .then(() => {
                    this.$emit('reload');
                    this.buttonStatus.register.splice(this.buttonStatus.register.indexOf(this.subvention.id), 1);
                })
                .catch((error) => this.showErrors(error));
        },
        changeScopeOfCare() {
            this.buttonStatus.contract.push(this.relatedContract.contractNumber);
            IsbjChildRepository
                .changeScope(this.relatedContract.contractNumber)
                .then(() => {
                    this.$emit('reload');
                    this.buttonStatus.contract.splice(this.buttonStatus.contract.indexOf(this.relatedContract.contractNumber), 1);
                })
                .catch((error) => this.showErrors(error));
        },
        showErrors(error) {
            if (error.message === 'isbj_api_error') {
                this.$notify.error('ISBJ hat auf die Anfrage mit einer ungültigen Antwort reagiert.');
            } else if (error.message === 'isbj_down') {
                this.$notify.error('Die ISBJ-Schnittstelle ist derzeit nicht erreichbar.');
            } else {
                this.$notify.error('Es ist ein Fehler aufgetreten. Bitte laden Sie die Seite neu.');
            }
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
tr.kgr-table__row {
    height: 56px;
    td.kgr-table__cell {
        .kgr-icon {
            vertical-align: middle;
        }
    }
}
.diff {
    background-color: #f9f6c1;
    color: #000;
    .diffContainer {
        display: flex;
        justify-content: space-between;
        div:first-of-type {
            margin-right: 2px;
        }
        div:last-of-type {
            margin-left: 2px;
            white-space: nowrap;
        }
    }
}
</style>
